import Nav from "./Nav.jsx";

export default Nav;



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/common/nav/index.js